import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
// import Tab from 'react-bootstrap/Tab';
// import Tabs from 'react-bootstrap/Tabs';
import { SlTab, SlTabGroup, SlTabPanel } from '@shoelace-style/shoelace/dist/react';
import Advertiser from './Advertiser'
import { useDispatch, useSelector } from 'react-redux';
import { SetComponentId } from '../../redux/counterSlice'
import Sales from './Sales'
import Finance from './Finance'
import { roles } from '../../utils/constants';
import B2B from './B2b'
import CryptoJS from 'crypto-js';
import config from '../../config.js';
import Company from './Company';
import Legal from "./Legal"
import Designer from './Designer';
import ContentWriter from './ContentWriter.js';

function Users() {
  const dispatch = useDispatch()
  dispatch(SetComponentId(1))
  const navigate = useNavigate()
  let salesUserType = "", activeModifiedType=""
  if (localStorage.getItem('role') === roles.salesperson && localStorage.getItem('salesTabFlag')) {
    const decryptedSalesTabPermissions = CryptoJS.AES.decrypt(localStorage.getItem('salesTabFlag'), config.B2B_SECRET_KEY);
    salesUserType = decryptedSalesTabPermissions.toString(CryptoJS.enc.Utf8)
    activeModifiedType = "sales"
  }
  else{
    activeModifiedType = "company"
  }
  const [activeTab, setActiveTab] = useState(activeModifiedType)

  useEffect(() => {
    const role = localStorage.getItem("role")
    if ((role !== roles.ops && role !== roles.financer && role !== roles.b2b) && !salesUserType) {
      navigate("/pagenotfound")
    }
  }, [navigate])

  const handleTabActivate = (event) => {
    setActiveTab(event.detail.name)
  }
  return (
    <div className="form-floating">{console.log(salesUserType)}
      <SlTabGroup onSlTabShow={handleTabActivate}>
        {!salesUserType && <><SlTab slot="nav" panel="company">Company</SlTab>
          <SlTabPanel name="company">{activeTab === 'company' && <Company />}</SlTabPanel></>}
        {!salesUserType && localStorage.getItem('role') !== roles.financer && <><SlTab slot="nav" panel="advertiser">Advertiser</SlTab>
          <SlTabPanel name="advertiser">{activeTab === 'advertiser' && <Advertiser />}</SlTabPanel></>}
        {localStorage.getItem('role') !== roles.financer && <SlTab slot="nav" panel="sales">Sales</SlTab>}
        <SlTabPanel name="sales">{activeTab === 'sales' && <Sales />}</SlTabPanel>
        {!salesUserType && localStorage.getItem('role') !== roles.financer && <><SlTab slot="nav" panel="finance">Finance</SlTab>
        <SlTabPanel name="finance">{activeTab === 'finance' && <Finance />}</SlTabPanel>
        <SlTab slot="nav" panel="b2b">B2B</SlTab>
          <SlTabPanel name="b2b">{activeTab === 'b2b' && <B2B />}</SlTabPanel></>}
        {!salesUserType && localStorage.getItem('role') !== roles.financer && <><SlTab slot="nav" panel="legal">Legal</SlTab>
          <SlTabPanel name="legal">{activeTab === 'legal' && <Legal />}</SlTabPanel></>}
        {!salesUserType && localStorage.getItem('role') === roles.b2b && <><SlTab slot="nav" panel="designer">Designer</SlTab>
          <SlTabPanel name="designer">{activeTab === 'designer' && <Designer />}</SlTabPanel></>}
        {!salesUserType && localStorage.getItem('role') === roles.b2b && <><SlTab slot="nav" panel="ContentWriter">ContentWriter</SlTab>
          <SlTabPanel name="ContentWriter">{activeTab === 'ContentWriter' && <ContentWriter />}</SlTabPanel></>}
      </SlTabGroup>
      {/* <Tabs activeKey={tab}
        onSelect={(k) => setTab(k)}
        className="mb-1" >
        <Tab eventKey="advertiser" title="Advertiser">
          {tab === "advertiser" && < Advertiser />}
        </Tab>
        <Tab eventKey="sales" title="Sales">
          {tab === "sales" && <Sales />}
        </Tab>
        <Tab eventKey="finance" title="Finance" >
          {tab === "finance" && <Finance />}
        </Tab>
      </Tabs> */}
    </div>
  )
}

export default Users